import { render, staticRenderFns } from "./WelcomeJomatik.vue?vue&type=template&id=cc386400&scoped=true"
import script from "./WelcomeJomatik.vue?vue&type=script&lang=js"
export * from "./WelcomeJomatik.vue?vue&type=script&lang=js"
import style0 from "./WelcomeJomatik.vue?vue&type=style&index=0&id=cc386400&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc386400",
  null
  
)

export default component.exports